import { Component } from '@angular/core';
import { Layout } from 'app/views/presentations/layouts/layout';
import { LayoutComponent } from 'app/views/presentations/layouts/layout.component';

@Component({
    selector: `psm-four-sections-layout-mirror-component]`,
    templateUrl: 'fourSectionsLayoutMirror.component.html',
    styleUrls: ['../layout.component.scss']
})

export class FourSectionsLayoutMirrorComponent extends LayoutComponent { }

export class FourSectionsLayoutMirror extends Layout {
    public type = 'FourSectionsLayoutMirror';
    public componentType = FourSectionsLayoutMirrorComponent;
    public numberOfSections = 4;
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/fourSectionsLayoutMirror/fourSectionsLayoutMirror.component.ts